var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "d-none d-sm-flex",
      attrs: { fluid: "", "grid-list-md": "" },
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-expansion-panels",
                {
                  attrs: { value: "0" },
                  model: {
                    value: _vm.searchPanel,
                    callback: function ($$v) {
                      _vm.searchPanel = $$v
                    },
                    expression: "searchPanel",
                  },
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        { staticClass: "list-search--header" },
                        [
                          _c(
                            "strong",
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v(" Search"),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        {
                          staticClass: "quickSearchPanel pa-0",
                          attrs: { ripple: "" },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Reservation")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "2" },
                                          },
                                          [_vm._v("Reference:")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "4" },
                                          },
                                          [
                                            _c("v-text-field", {
                                              model: {
                                                value:
                                                  _vm.search.reservation
                                                    .reference,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.reservation,
                                                    "reference",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.reservation.reference",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Hotel")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "4" },
                                          },
                                          [_vm._v("Hotel Code/Name: ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "4" },
                                          },
                                          [
                                            _c("v-text-field", {
                                              model: {
                                                value:
                                                  _vm.search.hotel.hotelKey,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.hotel,
                                                    "hotelKey",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.hotel.hotelKey",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Client")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "2" },
                                          },
                                          [_vm._v("Client Name: ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "4" },
                                          },
                                          [
                                            _c("v-text-field", {
                                              model: {
                                                value: _vm.search.client.name,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.client,
                                                    "name",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.client.name",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "2" },
                                          },
                                          [_vm._v("Client Email: ")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            attrs: { cols: "12", md: "4" },
                                          },
                                          [
                                            _c("v-text-field", {
                                              model: {
                                                value: _vm.search.client.email,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.client,
                                                    "email",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.client.email",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                                _c(
                                  "fieldset",
                                  [
                                    _c("legend", [_vm._v("Status")]),
                                    _vm._v(" "),
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "12",
                                              md: "6",
                                              lg: "4",
                                            },
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "hide-details": "",
                                                label: "Enquiries",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.loadAllReservations()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.search.status.enquiries,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.status,
                                                    "enquiries",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.status.enquiries",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "12",
                                              md: "6",
                                              lg: "4",
                                            },
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "hide-details": "",
                                                label:
                                                  "Awaiting Client Response",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.loadAllReservations()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.search.status.waiting,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.status,
                                                    "waiting",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.status.waiting",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "12",
                                              md: "6",
                                              lg: "4",
                                            },
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "hide-details": "",
                                                label: "Confirmed",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.loadAllReservations()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.search.status.confirmed,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.status,
                                                    "confirmed",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.status.confirmed",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "12",
                                              md: "6",
                                              lg: "4",
                                            },
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "hide-details": "",
                                                label: "Cancelled",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.loadAllReservations()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.search.status
                                                    .cancellations,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.status,
                                                    "cancellations",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.status.cancellations",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "12",
                                              md: "6",
                                              lg: "4",
                                            },
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "hide-details": "",
                                                label: "Quote Declined",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.loadAllReservations()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.search.status
                                                    .quoteDeclined,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.status,
                                                    "quoteDeclined",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.status.quoteDeclined",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "12",
                                              md: "6",
                                              lg: "4",
                                            },
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "hide-details": "",
                                                label: "Completed",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.loadAllReservations()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.search.status.completed,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.status,
                                                    "completed",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.status.completed",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-col",
                                          {
                                            attrs: {
                                              cols: "12",
                                              md: "6",
                                              lg: "4",
                                            },
                                          },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "hide-details": "",
                                                label: "Failed Instant",
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.loadAllReservations()
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.search.status
                                                    .failedInstant,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.search.status,
                                                    "failedInstant",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "search.status.failedInstant",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ies-green",
                                      on: {
                                        click: function ($event) {
                                          return _vm.loadAllReservations()
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", [_vm._v("search")]),
                                      _vm._v(" Search"),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-expansion-panels",
                {
                  attrs: { value: "0" },
                  model: {
                    value: _vm.addNewPanel,
                    callback: function ($$v) {
                      _vm.addNewPanel = $$v
                    },
                    expression: "addNewPanel",
                  },
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        { staticClass: "list-search--header" },
                        [
                          _c(
                            "strong",
                            [_c("v-icon", [_vm._v("add")]), _vm._v(" New")],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        { staticClass: "addNewPanel", attrs: { ripple: "" } },
                        [_c("ies-reservation-administration-new")],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-expansion-panels",
                {
                  attrs: { value: "0" },
                  model: {
                    value: _vm.legendPanel,
                    callback: function ($$v) {
                      _vm.legendPanel = $$v
                    },
                    expression: "legendPanel",
                  },
                },
                [
                  _c(
                    "v-expansion-panel",
                    [
                      _c(
                        "v-expansion-panel-header",
                        { staticClass: "list-search--header" },
                        [_c("strong", [_vm._v("Legend")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-expansion-panel-content",
                        {
                          staticClass: "quickSearchPanel",
                          attrs: { ripple: "" },
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("v-icon", [_vm._v("card_giftcard")]),
                                  _vm._v(
                                    " Gift vouchers were redeemed during this booking"
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("v-icon", [_vm._v("credit_card")]),
                                  _vm._v(
                                    " Virtual card issued for hotel to charge"
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("v-icon", [_vm._v("paid")]),
                                  _vm._v(
                                    " Full amount prepaid by client at time of booking"
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("v-icon", [_vm._v("bolt")]),
                                  _vm._v(
                                    " Reservation was made as an instant-booking"
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("v-icon", [_vm._v("mark_chat_unread")]),
                                  _vm._v(" Unread messages from client"),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("v-col", { attrs: { cols: "12", md: "2" } }, [
                                _c("span", {
                                  staticClass: "circle-icon response-overdue",
                                }),
                                _vm._v(" Needs attention"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "2" } },
                                [
                                  _c("v-icon", [_vm._v("star")]),
                                  _vm._v(" Test reservation/enquiry"),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "d-none d-md-block", attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  on: {
                    click: function ($event) {
                      return _vm.loadAllReservations()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("refresh")]), _vm._v(" Refresh")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mr-1",
                  attrs: { depressed: _vm.liveRefresh },
                  on: {
                    click: function ($event) {
                      return _vm.toggleLiveRefresh()
                    },
                  },
                },
                [
                  _c("v-icon", [_vm._v("refresh")]),
                  _vm._v(" Live View\n                "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { disabled: "" },
                  on: {
                    click: function ($event) {
                      return _vm.createNewReservation()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("add")]), _vm._v(" Create New")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    title: "View upcoming ARI on the property's daily planner",
                    href: _vm.dailyPlannerUrl,
                    disabled: !_vm.dailyPlannerUrl,
                  },
                },
                [
                  _c("v-icon", [_vm._v("edit_calendar")]),
                  _vm._v(" Daily Planner\n                "),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hasProblem
            ? _c(
                "v-alert",
                { attrs: { type: "info", value: _vm.liveRefresh } },
                [
                  _vm._v(
                    "\n                Live view mode is active. The data will refresh automatically\n             "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              !_vm.hasProblem && _vm.isLoading
                ? _c(
                    "v-card",
                    { staticClass: "pa-3 text-center" },
                    [
                      _vm._v(
                        "\n                     Loading...\n                     "
                      ),
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", color: "lime" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.hasProblem
                ? _c("v-card", { staticClass: "pa-3" }, [
                    _vm._v(
                      "\n                    Sorry, this content is not currently available\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.allReservations.length && !_vm.hasProblem && !_vm.isLoading
                ? _c("v-card", [
                    _vm._v(
                      "\n                    There are no enquiries or reservations to display\n                "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.allReservations, function (reservationGroup) {
                return !_vm.hasProblem && !_vm.isLoading
                  ? _c(
                      "v-card",
                      [
                        _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c(
                              "v-layout",
                              { attrs: { row: "", wrap: "" } },
                              [
                                _c(
                                  "v-col",
                                  {
                                    class: {
                                      "pa-0": _vm.$vuetify.breakpoint.smAndDown,
                                      "pa-3": _vm.$vuetify.breakpoint.mdAndUp,
                                    },
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c("h2", [
                                      _vm._v(
                                        _vm._s(reservationGroup.title) +
                                          " (" +
                                          _vm._s(
                                            reservationGroup.reservations.length
                                          ) +
                                          ")"
                                      ),
                                    ]),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(reservationGroup.description) +
                                        "\n                                "
                                    ),
                                    _c(
                                      "v-container",
                                      {
                                        staticClass:
                                          "d-none d-md-block pl-0 pr-0",
                                        attrs: { fluid: "" },
                                      },
                                      [
                                        _c(
                                          "v-layout",
                                          {
                                            staticClass: "grey lighten-4",
                                            attrs: { row: "", wrap: "" },
                                          },
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Reference\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Date Reserved\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            !_vm.hotelkey
                                              ? _c(
                                                  "v-col",
                                                  {
                                                    staticClass:
                                                      "font-weight-bold pt-1 pb-1",
                                                    attrs: { cols: "2" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                           Hotel\n                                       "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Arrival\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Departure\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Nights\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "2" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Client\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Quote (GBP)\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Checked\n                                       "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass:
                                                  "font-weight-bold pt-1 pb-1",
                                                attrs: { cols: "1" },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                           Status\n                                       "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-expansion-panels",
                                      _vm._l(
                                        reservationGroup.reservations,
                                        function (reservation, index) {
                                          return _c(
                                            "v-expansion-panel",
                                            {
                                              key: _vm.i,
                                              staticClass:
                                                "reservation-expansion-panel pa-0",
                                              attrs: {
                                                expand: "",
                                                focusable: "",
                                              },
                                              model: {
                                                value: _vm.listPanel,
                                                callback: function ($$v) {
                                                  _vm.listPanel = $$v
                                                },
                                                expression: "listPanel",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-expansion-panel-header",
                                                {
                                                  staticClass:
                                                    "pt-0 pb-0 pl-0 pr-0 pa-0",
                                                },
                                                [
                                                  _c(
                                                    "v-container",
                                                    {
                                                      staticClass: "pa-0",
                                                      attrs: { fluid: "" },
                                                    },
                                                    [
                                                      _c(
                                                        "v-layout",
                                                        {
                                                          attrs: {
                                                            row: "",
                                                            wrap: "",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-none",
                                                              attrs: {
                                                                cols: "5",
                                                                sm: "6",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              reservation.responseIsOverdue
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "circle-icon response-overdue",
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "strong",
                                                                {
                                                                  staticClass:
                                                                    "d-none d-sm-block d-md-none",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Reference:"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-flex align-center",
                                                              attrs: {
                                                                cols: "7",
                                                                sm: "6",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              reservation.responseIsOverdue
                                                                ? _c("span", {
                                                                    staticClass:
                                                                      "mr-1 circle-icon response-overdue d-none d-xl-block",
                                                                  })
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "strong",
                                                                {
                                                                  staticStyle: {
                                                                    "font-size":
                                                                      "100%",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      reservation.reference
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c("a", {
                                                                attrs: {
                                                                  name: reservation.reference,
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-xl-flex align-center",
                                                              attrs: {
                                                                cols: "7",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.dateFormatDDMMMYY(
                                                                      reservation.date_reservation
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-md-flex d-xl-none align-center",
                                                              attrs: {
                                                                cols: "7",
                                                                lg: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    _vm.dateFormatDDMMYY(
                                                                      reservation.date_reservation
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          !_vm.hotelkey
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "d-none d-sm-flex d-md-none",
                                                                  attrs: {
                                                                    cols: "5",
                                                                    md: "1",
                                                                  },
                                                                },
                                                                [
                                                                  _c("strong", [
                                                                    _vm._v(
                                                                      "Hotel:"
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          !_vm.hotelkey
                                                            ? _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "d-none d-sm-flex align-center",
                                                                  attrs: {
                                                                    cols: "7",
                                                                    md: "2",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                    (" +
                                                                      _vm._s(
                                                                        reservation
                                                                          .hotel
                                                                          .hotel_code
                                                                      ) +
                                                                      ") " +
                                                                      _vm._s(
                                                                        reservation
                                                                          .hotel
                                                                          .hotel_name
                                                                      ) +
                                                                      "\n                                            "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-sm-flex d-lg-none",
                                                              attrs: {
                                                                cols: "5",
                                                                lg: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  "Dates:"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-flex d-md-none",
                                                              attrs: {
                                                                cols: "7",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                Arrive " +
                                                                  _vm._s(
                                                                    reservation.date_arrival
                                                                  )
                                                              ),
                                                              _c("br"),
                                                              _vm._v(
                                                                " Depart " +
                                                                  _vm._s(
                                                                    reservation.date_departure
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-md-flex d-xl-none align-right",
                                                              attrs: {
                                                                cols: "12",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                 " +
                                                                  _vm._s(
                                                                    _vm.dateFormatDDMMYY(
                                                                      reservation.date_arrival
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-xl-flex align-right",
                                                              attrs: {
                                                                cols: "12",
                                                                lg: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                 " +
                                                                  _vm._s(
                                                                    _vm.dateFormatDDMMMYY(
                                                                      reservation.date_arrival
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-md-flex d-xl-none align-right",
                                                              attrs: {
                                                                cols: "12",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                 " +
                                                                  _vm._s(
                                                                    _vm.dateFormatDDMMYY(
                                                                      reservation.date_departure
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-xl-flex align-right",
                                                              attrs: {
                                                                cols: "12",
                                                                lg: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                 " +
                                                                  _vm._s(
                                                                    _vm.dateFormatDDMMMYY(
                                                                      reservation.date_departure
                                                                    )
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-sm-flex d-md-none",
                                                              attrs: {
                                                                cols: "6",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  "Nights:"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-sm-flex d-md-flex",
                                                              attrs: {
                                                                cols: "6",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                " +
                                                                  _vm._s(
                                                                    reservation.num_nights
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-none",
                                                              attrs: {
                                                                cols: "5",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  "Client:"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-flex align-center",
                                                              attrs: {
                                                                cols: "7",
                                                                md: "2",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    reservation
                                                                      .client
                                                                      .first_name
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    reservation
                                                                      .client
                                                                      .last_name
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-none",
                                                              attrs: {
                                                                cols: "5",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  "Quote (GBP):"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-flex align-right",
                                                              attrs: {
                                                                cols: "7",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                    " +
                                                                  _vm._s(
                                                                    reservation.quote_amount_gbp
                                                                  ) +
                                                                  "\n                                            "
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-md-none",
                                                              attrs: {
                                                                cols: "5",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  "Checked:"
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-none d-md-flex align-right",
                                                              attrs: {
                                                                cols: "7",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      reservation.has_been_checked,
                                                                    expression:
                                                                      "reservation.has_been_checked",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "checkbox",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    Array.isArray(
                                                                      reservation.has_been_checked
                                                                    )
                                                                      ? _vm._i(
                                                                          reservation.has_been_checked,
                                                                          null
                                                                        ) > -1
                                                                      : reservation.has_been_checked,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.toggleChecked(
                                                                        reservation
                                                                      )
                                                                    },
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          reservation.has_been_checked,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c =
                                                                          $$el.checked
                                                                            ? true
                                                                            : false
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            null,
                                                                          $$i =
                                                                            _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            _vm.$set(
                                                                              reservation,
                                                                              "has_been_checked",
                                                                              $$a.concat(
                                                                                [
                                                                                  $$v,
                                                                                ]
                                                                              )
                                                                            )
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            _vm.$set(
                                                                              reservation,
                                                                              "has_been_checked",
                                                                              $$a
                                                                                .slice(
                                                                                  0,
                                                                                  $$i
                                                                                )
                                                                                .concat(
                                                                                  $$a.slice(
                                                                                    $$i +
                                                                                      1
                                                                                  )
                                                                                )
                                                                            )
                                                                        }
                                                                      } else {
                                                                        _vm.$set(
                                                                          reservation,
                                                                          "has_been_checked",
                                                                          $$c
                                                                        )
                                                                      }
                                                                    },
                                                                },
                                                              }),
                                                              _vm._v(
                                                                " \n                                                 "
                                                              ),
                                                              reservation &&
                                                              reservation.initialed_by_user
                                                                ? _c(
                                                                    "a",
                                                                    {
                                                                      attrs: {
                                                                        href: _vm.makeInitialedEmailUrl(
                                                                          reservation
                                                                        ),
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          reservation.initialed_by_user.first_name.substring(
                                                                            0,
                                                                            1
                                                                          )
                                                                        ) +
                                                                          _vm._s(
                                                                            reservation.initialed_by_user.last_name.substring(
                                                                              0,
                                                                              1
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-flex align-center",
                                                              attrs: {
                                                                cols: "12",
                                                                md: "1",
                                                              },
                                                            },
                                                            [
                                                              reservation.has_voucher
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        title:
                                                                          "Gift vouchers were redeemed",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "card_giftcard"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              reservation.has_van
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        title:
                                                                          "Virtual credit card created",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "credit_card"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              reservation.is_prepaid
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        title:
                                                                          "Full advance payment made to i-escape",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "paid"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              reservation.unreadMessages
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        title:
                                                                          "Has unread messages",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mark_chat_unread"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              reservation.is_instant
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        title:
                                                                          "Instant booking",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "bolt"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              reservation.is_test
                                                                ? _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        title:
                                                                          "Test booking",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "star"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "d-md-none",
                                                              attrs: {
                                                                cols: "12",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  staticClass:
                                                                    "ies-green",
                                                                  attrs: {
                                                                    block: "",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Respond"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-expansion-panel-content",
                                                { staticClass: "pa-0" },
                                                [
                                                  _c(
                                                    "v-card",
                                                    { staticClass: "pa-0" },
                                                    [
                                                      _c(
                                                        "v-card-text",
                                                        [
                                                          _c(
                                                            "ies-reservation-administration-management",
                                                            {
                                                              attrs: {
                                                                reservationkey:
                                                                  reservation.reservation_key,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e()
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }